/*
 * Shipping protection for the cart drawer and cart page: optional, the shopper ticks it to add it.
 *
 * snippets/tcb-shipping-protection.liquid renders the box with the variant the cart SHOULD hold
 * (data-desired, by order value) and the protection line it DOES hold (data-current, data-key,
 * data-qty). This script makes the cart match: tick adds, untick removes, and after any re-render
 * it swaps to the right tier, holds quantity at 1, and drops protection from carts with no livestock.
 *
 * OPTIONAL since 10-30 (Alex): unticked by default, added only when the shopper ticks it (or picks a Friday
 * delivery, which tcb-delivery-day.js handles). Was default on 10-29 to 10-30.
 * Every tick or untick is saved as the cart attribute "Shipping protection" (Added / Declined + time),
 * which prints on the order. A saved "Declined" stops the auto add for the rest of that cart.
 * The auto add checks /cart.js first so a stale render can't add it twice (fix 10-30).
 *
 * Loaded from layout/theme.liquid and bound at document level, like lag-consent.js, so it survives
 * drawer injection and section morphs.
 */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false;
  var queued = false;
  var failures = 0; // stop auto-fixing after repeated errors so a broken cart can't loop requests
  var declined = false; // shopper unticked it during this page view

  function record(choice) {
    return post('cart/update.js', {
      attributes: { 'Shipping protection': choice + ' ' + new Date().toISOString() }
    });
  }

  function post(path, body) {
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) throw new Error(path + ' ' + response.status);
      return response;
    });
  }

  // Same event the frag add-on fires; the theme re-renders the drawer and cart page from it.
  function announce() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: 'tcb-shipping-protection',
              data: { source: 'tcb-shipping-protection', itemCount: cart.item_count }
            }
          })
        );
      });
  }

  function run(task) {
    if (busy) return;
    busy = true;
    task()
      .then(function () {
        failures = 0;
        return announce();
      })
      .catch(function () {
        failures += 1;
      })
      .then(function () {
        busy = false;
      });
  }

  function reconcile() {
    if (busy || failures >= 3) return;

    var orphan = document.querySelector('[data-tcb-sp-orphan]');
    if (orphan) {
      run(function () {
        return post('cart/change.js', { id: orphan.getAttribute('data-key'), quantity: 0 });
      });
      return;
    }

    var box = document.querySelector('[data-tcb-sp]');
    if (!box) return;
    var current = box.getAttribute('data-current');
    if (!current) return; // Optional since 10-30: nothing is added until the shopper ticks the box.
    var desired = box.getAttribute('data-desired');

    if (current !== desired) {
      var updates = {};
      updates[current] = 0;
      updates[desired] = 1;
      run(function () {
        return post('cart/update.js', { updates: updates });
      });
    } else if (Number(box.getAttribute('data-qty') || 1) !== 1) {
      run(function () {
        return post('cart/change.js', { id: box.getAttribute('data-key'), quantity: 1 });
      });
    }
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.classList || !input.classList.contains('tcb-sp__box')) return;
    var box = input.closest('[data-tcb-sp]');
    if (!box) return;

    if (busy) {
      input.checked = !input.checked; // ignore clicks while a cart request is in flight
      return;
    }

    // The drawer and the cart page can both be in the DOM; keep their boxes in step.
    Array.prototype.forEach.call(document.querySelectorAll('.tcb-sp__box'), function (other) {
      other.checked = input.checked;
    });

    failures = 0;
    if (input.checked) {
      declined = false;
      run(function () {
        return post('cart/add.js', { items: [{ id: Number(box.getAttribute('data-desired')), quantity: 1 }] }).then(function () {
          return record('Added');
        });
      });
    } else {
      declined = true;
      run(function () {
        var key = box.getAttribute('data-key');
        var remove = key ? post('cart/change.js', { id: key, quantity: 0 }) : Promise.resolve();
        return remove.then(function () {
          return record('Declined');
        });
      });
    }
  });

  // Coalesce DOM churn into one reconcile pass. setTimeout, not rAF, so background tabs still sync.
  function schedule() {
    if (queued) return;
    queued = true;
    window.setTimeout(function () {
      queued = false;
      reconcile();
    }, 60);
  }

  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
})();
